import gsap from 'gsap';
import Tools from '../components/tools';
export default class Nav {
    constructor() {
        this.tools = new Tools();

        this.loader();
        this.burger();
        if (window.innerWidth < 1024) {
            this.hoverMobile();
            this.accordeons();
        }
        else {
            this.customHover();
        }

        this.scrollDirection();
    }

    burger() {
        const burgerBtn = document.querySelector('.navigation .burger'),
            navigation = document.querySelector('.navigation');

        if (burgerBtn) {
            burgerBtn.addEventListener('click', function () {
                navigation.classList.toggle('open');
            });
        }
    }

    scrollDirection() {
        let lastScrollTop = 0;
        document.addEventListener('scroll', function () {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                // downscroll code
                document.querySelector('.navigation').classList.remove('js-scrollup');
            } else if (st < lastScrollTop) {
                // upscroll code
                document.querySelector('.navigation').classList.add('js-scrollup');
            }
            if(st < 1) {
                document.querySelector('.navigation').classList.remove('js-scrollup');
            }

            if(st > document.querySelector('.navigation').offsetHeight) {
                document.querySelector('.navigation').classList.add('js-translate');
            } else {
                document.querySelector('.navigation').classList.remove('js-translate');
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    }

    loader() {
        const loader = document.querySelector('.loader');
        if (loader) {
            if (sessionStorage.getItem('loaderPlayed') != 'true') {
                const video = document.querySelector('.loader video');
                video.onended = () => {
                    gsap.to(
                        loader,
                        {
                            yPercent: -100,
                            duration: 1,
                            ease: 'power4.out',
                            delay: .5
                        }
                    );

                    gsap.to(
                        video,
                        {
                            yPercent: 35,
                            duration: 1,
                            ease: 'power4.out',
                            delay: .5
                        }
                    );
                }

                sessionStorage.setItem('loaderPlayed', 'true');
            } else {
                loader.style.display = 'none';
            }
        }
    }

    hoverMobile() {
        const btns = document.querySelectorAll('.menu__left .menu__item--hasSub .menu__label');
        if (btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (btn.parentElement.classList.contains('js-open')) {
                        btn.parentElement.classList.remove('js-open');

                        btn.nextElementSibling.style.height = 'auto';
                        const autoHeight = btn.nextElementSibling.offsetHeight;

                        return gsap.fromTo(btn.nextElementSibling, {
                            height: autoHeight,
                        }, {
                            height: 0,
                            ease: 'power4.inOut',
                            duration: 0.85,
                        });
                    } else {
                        this.tools.fixedToAuto(btn.nextElementSibling, 0);
                        btn.parentElement.classList.add('js-open');
                    }
                })
            });
        }
    }

    customHover() {
        const leaveBtns = document.querySelectorAll('.navigation .menu__left, .navigation .menu__left > .menu__item:not(.menu__item-hasSub)');
        if (leaveBtns.length > 0) {
            leaveBtns.forEach((btn) => {
                btn.addEventListener('mouseleave', () => {
                    document.querySelector('.navigation .menu__left').classList.remove('js-open');
                    gsap.to(
                        document.querySelector('main'),
                        {
                            filter: 'blur(0px)',
                            duration: 0.35,
                            ease: 'power4.inOut',
                            onComplete: function () {
                                gsap.set(this.targets(), {
                                    clearProps: 'all',
                                });
                            }
                        }
                    );
                });
            });
        }

        const items = document.querySelectorAll('.menu__item--hasSub');
        if (items.length > 0) {
            items.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    if (!item.parentElement.classList.contains('js-open')) {
                        item.parentElement.classList.add('js-open');

                        gsap.to(
                            document.querySelector('main'),
                            {
                                filter: 'blur(25px)',
                                duration: 0.35,
                                ease: 'power4.inOut',
                            }
                        );
                    }

                    gsap.to(
                        item.querySelector('.menu__sub'),
                        {
                            height: (window.innerHeight / 100 * 75) - document.querySelector('.navigation').offsetHeight,
                            duration: 0.35,
                            ease: 'power4.inOut',
                            onComplete: () => {
                                document.querySelectorAll('.navigation .menu__sub').forEach((submenu) => {
                                    gsap.set(
                                        submenu,
                                        {
                                            height: (window.innerHeight / 100 * 75) - document.querySelector('.navigation').offsetHeight
                                        }
                                    );
                                });
                            },
                        }
                    );
                });

                item.addEventListener('mouseleave', () => {
                    if (document.querySelector('.navigation .menu__left').classList.contains('js-open')) {

                        gsap.to(
                            item.querySelector('.menu__sub'),
                            {
                                height: 0,
                                duration: 0.35,
                                ease: 'power4.inOut',
                                onComplete: () => {
                                    document.querySelectorAll('.navigation .menu__sub').forEach((submenu) => {
                                        gsap.set(
                                            submenu,
                                            {
                                                height: 0
                                            }
                                        );
                                    });
                                },
                            }
                        );
                    }
                });
            });
        }
    }

    accordeons() {
        const btns = document.querySelectorAll('.menu-item-label');
        const that = this.tools;
        if(btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if(document.querySelector('.menu-item.js-open') && document.querySelector('.menu-item.js-open') != btn.parentElement) {
                        that.autoToFixed(document.querySelector('.menu-item.js-open .sub-menu'), 0);
                        document.querySelector('.menu-item.js-open').classList.remove('js-open');
                    }

                    if(btn.parentElement.classList.contains('js-open')) {
                        btn.parentElement.classList.remove('js-open');
                        that.autoToFixed(btn.parentElement.querySelector('.sub-menu'), 0);
                    } else {
                        btn.parentElement.classList.add('js-open');
                        that.fixedToAuto(btn.parentElement.querySelector('.sub-menu'), 0);
                    }
                });
            });
        }
    }
}